import { render, staticRenderFns } from "./LegalEntitiesList.vue?vue&type=template&id=3783337c"
import script from "./LegalEntitiesList.vue?vue&type=script&lang=js"
export * from "./LegalEntitiesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports